export enum LayoutTypes {
  List = 'LIST',
  BigCards = 'BIG_CARDS',
  SmallCards = 'SMALL_CARDS',
}
